import Typography from '@mui/material/Typography';

import { VisuallyHidden } from '@/components/atoms';

import { gallery as copy } from '../content';

type Props = { shown: number; total: number };

/**
 * How much of the archive is on screen. Sits above the wall.
 *
 * ## The announcement is separate from the visible line
 *
 * The visible line is `aria-hidden` and a hidden live region carries the same
 * sentence. Pressing "Load more" appends twelve tiles below the fold, which is
 * silent to a screen reader and invisible to anyone using a magnifier — the
 * only other feedback is the button being briefly disabled. `polite`, so it
 * waits for a pause rather than interrupting, and it names the new total
 * because that is the useful fact, not the word "loaded".
 */
export function DeliveryGalleryCount({ shown, total }: Props) {
  return (
    <>
      <Typography aria-hidden variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
        {copy.resultsLabel} {shown} of {total}
      </Typography>
      <VisuallyHidden live="polite">
        {`Showing ${shown} of ${total} delivered cars.`}
      </VisuallyHidden>
    </>
  );
}
